/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import Popover from '@react/react-spectrum/Popover';
import PropTypes from 'prop-types';
import React, {lazy, Suspense} from 'react';
import Wait from '@react/react-spectrum/Wait';
import './ShellSandboxSwitcher.scss';

const ShellSandboxSwitcher = lazy(() => import('./ShellSandboxSwitcher'));

const ShellSandboxSwitcherPopover = props => (
  <Popover
    className="spectrum-Shell-sandboxSwitcher-popover"
    isDialog={false}
    role="dialog"
    {...props}>
    <Suspense fallback={<Wait centered />}>
      <ShellSandboxSwitcher {...props} />
    </Suspense>
  </Popover>
);

ShellSandboxSwitcherPopover.defaultProps = {
  onSandboxChange: () => {},
  sandboxes: []
};

ShellSandboxSwitcherPopover.propTypes = {
  onSandboxChange: PropTypes.func,
  recentSandboxes: PropTypes.array,
  sandboxes: PropTypes.array,
  selectedSandbox: PropTypes.object,
  userRecentSandboxesHandler: PropTypes.func
};

export default ShellSandboxSwitcherPopover;
